import { useLocation } from '@reach/router'
import {
  StyledMainMenu,
  StyledNavbar,
  StyledNavitem,
  StyledNavlink,
  StyledSubmenu,
  StyledMegamenu,
  StyledMegaTitle
} from './style'
import { usePageContext } from '@context/PageContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/pro-solid-svg-icons/faHome'
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown'

const MainMenu = ({
  menuData,
  color = 'dark',
  space = 1,
  vSpace = 1,
  bottomLine = true,
  alignment = 'center',
  ...props
}) => {
  const location = useLocation()
  const adjustedLocation =
    location.pathname.length > 1 && location.pathname.endsWith('/')
      ? location.pathname.slice(0, -1)
      : location.pathname

  const { locale } = usePageContext()

  return (
    <StyledMainMenu $alignment={alignment} {...props}>
      <StyledNavbar>
        {menuData?.map((menu) => {
          const submenu = menu.submenu?.length > 0 ? menu.submenu : null
          const megamenu = menu.megamenu ? menu.megamenu : null
          return (
            <StyledNavitem
              className="nav-item"
              key={`mainmenu-${menu.id}`}
              hasSubmenu={submenu}
              hasMegamenu={megamenu}
              $space={space}
              $alignment={alignment}
            >
              <StyledNavlink
                className="nav-link"
                path={menu.link}
                hassubmenu={submenu || megamenu ? 'true' : 'false'}
                $isSelected={
                  submenu?.some((obj) => obj.link === adjustedLocation) ||
                  menu.link === adjustedLocation
                }
                $color={color}
                $vSpace={vSpace}
                $bottomLine={bottomLine}
                aria-label={menu.text}
              >
                {menu.link === `/${locale}` ? (
                  <FontAwesomeIcon icon={faHome} />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: menu.text }} />
                )}
                {/* (submenu || megamenu) && (
                                    <i className="icon fa fa-angle-down"></i>
                                ) */}
              </StyledNavlink>
              {submenu && (
                <StyledSubmenu className="submenu">
                  {submenu.map((subitem, i) => {
                    const hasSubmenuLevelTwo = subitem.isSubmenu
                    const submenuLevelTwo = subitem.submenu
                    return (
                      <StyledNavitem
                        className="nav-item"
                        key={`submenu-${menu.id}-${i}`}
                        $subitem
                      >
                        <StyledNavlink
                          className="nav-link"
                          path={subitem.link}
                          $bottomLine={bottomLine}
                          $sublink
                        >
                          <span>{subitem.text}</span>
                          {hasSubmenuLevelTwo && (
                            <FontAwesomeIcon
                              className="icon"
                              icon={faAngleDown}
                            />
                          )}
                        </StyledNavlink>
                        {submenuLevelTwo && (
                          <StyledSubmenu>
                            {submenuLevelTwo.map((subitemLevelTwo, j) => {
                              return (
                                <StyledNavitem
                                  key={`submenu-${menu.id}-${i}-${j}`}
                                  $subitem
                                >
                                  <StyledNavlink
                                    path={subitemLevelTwo.link}
                                    $sublink
                                    $bottomLine={bottomLine}
                                  >
                                    {subitemLevelTwo.text}
                                  </StyledNavlink>
                                </StyledNavitem>
                              )
                            })}
                          </StyledSubmenu>
                        )}
                      </StyledNavitem>
                    )
                  })}
                </StyledSubmenu>
              )}
              {megamenu && (
                <StyledMegamenu className="megamenu">
                  {megamenu.map((megaitem, i) => {
                    const megaSubmenu = megaitem.submenu
                    return (
                      <li key={`megamenu-${menu.id}-${i}`}>
                        <StyledMegaTitle>{megaitem.title}</StyledMegaTitle>
                        {megaSubmenu && (
                          <ul>
                            {megaSubmenu.map((megaSubitem, j) => {
                              return (
                                <StyledNavitem
                                  key={`megasubmenu-${i}-${j}`}
                                  $megitem
                                >
                                  <StyledNavlink
                                    path={megaSubitem.link}
                                    $bottomLine={bottomLine}
                                    $sublink
                                  >
                                    <span>{megaSubitem.text}</span>
                                  </StyledNavlink>
                                </StyledNavitem>
                              )
                            })}
                          </ul>
                        )}
                      </li>
                    )
                  })}
                </StyledMegamenu>
              )}
            </StyledNavitem>
          )
        })}
      </StyledNavbar>
    </StyledMainMenu>
  )
}

export default MainMenu
